module.exports = __webpack_public_path__ + "img/legalPolicies-terms-conditions.05a17813.svg";